const EmailRequired = `Please Enter Your email`;
const PasswordRequired = `Please Enter Your Password`;
const PasswordRegexText = `Password must be 8+ characters with at least one uppercase, one lowercase, one number, and one special character`;
const PasswordConfirmationRequired = `Please confirm your password`;
const PasswordConfirmationMatching = `passsowrd and password confirmation should be the same`;

export {
    EmailRequired,
    PasswordRequired,
    PasswordRegexText,
    PasswordConfirmationRequired,
    PasswordConfirmationMatching,
};
